import {
  PERMISSIONCATEGORY_LOADING,
  GET_PERMISSIONCATEGORY,
  GET_PERMISSIONCATEGORY_SUCCESS,
  GET_PERMISSIONCATEGORY_FAIL,
  ADD_PERMISSIONCATEGORY_SUCCESS,
  ADD_PERMISSIONCATEGORY_FAIL,
  DELETE_PERMISSIONCATEGORY_SUCCESS,
  DELETE_PERMISSIONCATEGORY_FAIL,
  UPDATE_PERMISSIONCATEGORY_SUCCESS,
  UPDATE_PERMISSIONCATEGORY_FAIL,
  PERMISSIONCATEGORY_RESET
} from "./actionType";

const INIT_STATE = {
  permissionCategories: [],
  error: {},
};

const PermissionCategory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PERMISSIONCATEGORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PERMISSIONCATEGORY:
          return {
            ...state,
            permissionCategories: action.payload.data,
            isPermissionCategoryCreated: false,
            isPermissionCategorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PERMISSIONCATEGORY_FAIL:
      switch (action.payload.actionType) {
        case GET_PERMISSIONCATEGORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPermissionCategoryCreated: false,
            isPermissionCategorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PERMISSIONCATEGORY: {
      return {
        ...state,
        isPermissionCategoryCreated: false,
        loading: true,
      };
    }

    case PERMISSIONCATEGORY_LOADING: {
      return {
        ...state,
        isPermissionCategoryCreated: false,
        loading: true,
      };
    }

    case ADD_PERMISSIONCATEGORY_SUCCESS:
      return {
        ...state,
        isPermissionCategoryCreated: true,
        loading: false,
        permissionCategories: [action.payload.data, ...state.permissionCategories],
      };

    case ADD_PERMISSIONCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PERMISSIONCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        permissionCategories: state.permissionCategories.filter(
          permissionCategory => permissionCategory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PERMISSIONCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PERMISSIONCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        permissionCategories: state.permissionCategories.map(permissionCategory =>
          permissionCategory.id.toString() === action.payload.data.id.toString() ? { ...permissionCategory, ...action.payload.data } : permissionCategory
        ),
      };

    case UPDATE_PERMISSIONCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PERMISSIONCATEGORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PermissionCategory;